export const TooltipHelpText = {
  MPPI: {
    MonthlyMortgagePayment:
      "The maximum total monthly benefit is £3000 or 75% of their gross monthly income (whichever is the lower).",
    AssociatedPremiums:
      "Customers have the option to cover associated premiums include mortgage related insurance payments, like buildings and contents insurance that the customer would like to protect.",
    BenefitUpliftAmount:
      "Customers have the option to increase their benefit insured by an additional 33% of their mortgage payment and related insurance premiums for additional peace of mind to cover other expenses, like household bills. The maximum total monthly benefit is £3000 or 75% of their gross monthly income (whichever is the lower).",
    TotalMonthlyBenefit:
      "This is the total amount of monthly benefit the customer would receive in the event of a claim. The maximum benefit is £3000 or 75% of their gross monthly income (whichever is the lower). Where there is more than one applicant, the customer chooses how much each applicant will receive.",
  },
};
